<template>
    <div class="list-container">
        <div class="panel-item" v-for="item in list" :key="item.value" @click="handleClick(item)">
            <div class="label" :class="{'active':ismultiple? myValue.includes(item.value): myValue === item.value}">{{item.label}}</div>
            <div class="icon-wrapper">
                <i class="post-icon post-icon-checked-round post-timeselect__selected" v-show="ismultiple? myValue.includes(item.value): myValue === item.value"></i>
                <i class="post-icon post-icon-circle-outline post-timeselect__unselected" v-show="ismultiple? !myValue.includes(item.value): myValue !== item.value"></i>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'selectList',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    ismultiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Array],
      default: () => this.ismultiple ? [] : ''
    }
  },
  data () {
    return {
      myValue: this.value
    }
  },
  watch: {
    value (val) {
      this.myValue = val
    }
  },
  methods: {
    handleClick (item) {
      if (this.ismultiple) {
        this.myValue = this.myValue.includes(item.value) ? this.myValue.filter(i => i !== item.value) : this.myValue.concat(item.value)
      } else {
        this.myValue = this.myValue === item.value ? '' : item.value
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./index";
</style>
